import { TemplateEnumsRoute } from '../../../constants/api-endpoints';
import { TemplateType } from '../../../entities/template-type';
import { useQuery } from 'react-query';
import * as RestApi from 'core/network/RestApi';
import { generatePath } from 'react-router';

export const useGetTemplateTypes = () => {
  return useQuery(['types'], async () => {
    const result = await RestApi.get<TemplateType>(generatePath(TemplateEnumsRoute.TEMPLATE_TYPES));
    return result.data;
  });
};
